export default "__VITE_ASSET__w3E5Bax___"